import {Component, Input} from '@angular/core';
import {MyPlan} from '@ox/typings';

@Component({
  selector: 'webu-plan-transitions',
  templateUrl: './plan-transitions.component.html'
})
export class PlanTransitionsComponent {
  @Input() transitionPlans: MyPlan[] = [];
}
